import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, Row, Col, Divider, Icon, Button, Input, DatePicker, Select, TimePicker, message, Modal } from 'antd';
import moment from 'moment';
import Papa from 'papaparse';

// Actions
import { 
    get_meetings_reports, 
    update_meetins_fields, 
    get_initial_users, 
    delete_meeting } from './actions/meetings.action';

let timer,x;
const { RangePicker } = DatePicker;
const Option = Select.Option;
const dateFormat = 'YYYY/MM/DD';
const timeFormat = 'HH:mm';
const confirm = Modal.confirm;
class MeetingReports extends Component {

    constructor( props ){
        super( props );

        this.state = {
            data: [],
            filtered_data: [],
            users_list: [],
            user: '',
            start_date: '',
            end_date: ''
        }

        this.handleDownload = this.handleDownload.bind( this );
        this.handleUpdateInput = this.handleUpdateInput.bind( this );
        this.handleDateFilters = this.handleDateFilters.bind( this );
        this.handleUserFilter = this.handleUserFilter.bind( this );
        this.handleDeleteMeeting = this.handleDeleteMeeting.bind( this );

    }

    handleDeleteMeeting( id ){
        
        let self = this;
        
        confirm({
            title: 'Do you Want to delete this Meeting?',
            onOk() {
                self.props.delete_meeting( id );
            },
            onCancel() {
                // Nothing
            },
        });

    }

    handleUserFilter( value ){
        this.props.history.push( '/hr-reports/meetings/' + this.state.start_date + '/' + this.state.end_date + '/' + value  );
        this.props.get_meetings_reports( this.state.start_date, this.state.end_date, value );
        this.setState({
            user: value
        });
    }

    handleDateFilters( date, dateString ){
        this.props.history.push( '/hr-reports/meetings/' + dateString[0] + '/' + dateString[1] + '/' + this.state.user  );
        this.props.get_meetings_reports( dateString[0], dateString[1], this.state.user );
        this.setState({
            start_date: dateString[0],
            end_date: dateString[1]
        });
    }

    handleUpdateInput(  id, value, key  ){
        let self = this;
        clearTimeout(timer);
        timer = setTimeout(() => {
            self.props.update_meetins_fields( id, key, value );
        }, 700);
    }

    handleDownload(){

        let tempData = this.state.filtered_data;
    
        if( tempData ){

            let tempData = this.state.data;
            let data = [];
            let final_data = [];

            tempData.map( ( item, i ) => {
                let stack = {
                    'name': item.full_name,
                    'date': item.date,
                    'meeting_in': item.time_in,
                    'meeting_out': item.time_out,
                    'meeting_out_duration': item.duration,
                    'agency': item.agency,
                    'purpose_of_visit': item.purpose_of_visit,
                    'meeting_outcome': item.meeting_outcome
                }

                final_data.push( stack );

            });


            let csvData = Papa.unparse( final_data );
            let filename = 'meetings.csv';

            var link = window.document.createElement("a");
            link.setAttribute("href", "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(csvData));
            link.setAttribute("download", filename );
            link.click();

        }

    }


    componentWillMount(){

        if( this.props.match.params.start_date &&
            this.props.match.params.end_date &&
            this.props.match.params.user ){

            this.setState({
                user: this.props.match.params.user,
                start_date: this.props.match.params.start_date,
                end_date: this.props.match.params.end_date
            })
    
            this.props.get_initial_users();
            this.props.get_meetings_reports( this.props.match.params.start_date, this.props.match.params.end_date, this.props.match.params.user );
            this.props.history.push( '/hr-reports/meetings/' + this.props.match.params.start_date +'/'+ this.props.match.params.end_date + '/' + this.props.match.params.user );

        } else {

            const start_date = moment().clone().startOf('month').format('YYYY-MM-DD');
            const end_date = moment().clone().endOf('month').format('YYYY-MM-DD');
        
            this.setState({
                user: 'all',
                start_date: start_date,
                end_date: end_date
            })
    
            this.props.get_initial_users();
            this.props.get_meetings_reports( start_date, end_date, 'all' );
            this.props.history.push( '/hr-reports/meetings/' + start_date +'/'+ end_date+ '/all' );

        }
    
    }

    componentWillReceiveProps( nextProps ){
        if( nextProps.hr_meetings.length !== 0 ){

            if( nextProps.hr_meetings.STATUS.CODE === "200" &&
                nextProps.hr_meetings.STATUS.MESSAGE === "Successfully Listed Meetings" ){

                this.setState({
                    data: nextProps.hr_meetings.OUTPUT.DATA
                });
            }

            if( nextProps.hr_meetings.STATUS.CODE === "200" &&
                nextProps.hr_meetings.STATUS.MESSAGE === "Successfully Listed Users" ){

                this.setState({
                    users_list: nextProps.hr_meetings.OUTPUT.DATA
                });
            }

            if( nextProps.hr_meetings.STATUS.CODE === "201" &&
                nextProps.hr_meetings.STATUS.MESSAGE === "Successfully Updated Meetings" ){
                message.success( nextProps.hr_meetings.STATUS.MESSAGE );
                this.props.get_meetings_reports( this.state.start_date, this.state.end_date, this.state.user );
            }

            if( nextProps.hr_meetings.STATUS.CODE === "201" &&
                nextProps.hr_meetings.STATUS.MESSAGE === "Successfully Deleted Meeting" ){
                message.success( nextProps.hr_meetings.STATUS.MESSAGE );
                this.props.get_meetings_reports( this.state.start_date, this.state.end_date, this.state.user );
            }

        }

    }

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => this.handleSearch(selectedKeys, confirm)}
                    icon="search"
                    size="small"
                    style={{ width: 90, marginRight: 8 }}>
                    Search
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>Reset</Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) => 
            record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
                if (visible) {
                    setTimeout(() => this.searchInput.select() );
                } 
            }
            
    });

    handleSearch = (selectedKeys, confirm) => {
        confirm();
        this.setState({ searchText: selectedKeys[0] });
    }
    
    handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });
    }

    render() {

        const columns = [
            {
                title: "Employee Name",
                key: "full_name",
                dataIndex: "full_name",
                width: '12.5%',
                ...this.getColumnSearchProps( 'full_name' )
            },
            {
                title: "Date",
                key: "date",
                width: '12.5%',
                render: ( record ) => <DatePicker
                    onChange={ (e, dates) =>  this.handleUpdateInput( record.meeting_id, dates, 'date' ) }
                    defaultValue={moment( record.date , dateFormat )}/>
            },
            {
                title: "Start of Meeting",
                key: "time_out",
                width: '12.5%',
                render: ( record ) => <TimePicker 
                    format={ timeFormat }
                    onChange={ (e, timeString) =>  this.handleUpdateInput( record.meeting_id, timeString, 'time_out' ) }
                    defaultValue={ moment( record.time_out, timeFormat ) } />
            },
            {
                title: "End of Meeting",
                key: "time_in",
                width: '12.5%',
                render: ( record ) => <TimePicker 
                    format={ timeFormat }
                    onChange={ (e, timeString) =>  this.handleUpdateInput( record.meeting_id, timeString, 'time_in' ) }
                    defaultValue={ moment( record.time_in, timeFormat ) } />
            },
            {
                title: "Meeting Duration",
                key: "duration",
                dataIndex: "duration",
                width: '12.5%',
            },
            {
                title: "Client | Agency",
                key: "agency",
                width: '12.5%',
                ...this.getColumnSearchProps( 'agency' ),
                render: ( record ) => <Input 
                    onChange={ (e) => this.handleUpdateInput( record.meeting_id, e.target.value, 'agency' ) }    
                    defaultValue={ record.agency } />
            },  
            {
                title: "Purpose of Visit",
                key: "purpose_of_visit",
                width: '12.5%',
                ...this.getColumnSearchProps( 'purpose_of_visit' ),
                render: ( record ) => <Input 
                    onChange={ (e) => this.handleUpdateInput( record.meeting_id, e.target.value, 'purpose_of_visit' ) }
                    defaultValue={ record.purpose_of_visit } />
            },
            {
                title: "Meeting Outcome",
                key: "meeting_outcome",
                width: '12.5%',
                ...this.getColumnSearchProps( 'meeting_outcome' ),
                render: ( record ) => <Input 
                    onChange={ (e) => this.handleUpdateInput( record.meeting_id, e.target.value, 'meeting_outcome' ) }
                    defaultValue={ record.meeting_outcome } />,
            },{
                title: 'Actions',
                key: 'action',
                render: ( record ) => <Button
                type={"danger"}
                icon="delete" 
                onClick={ () => this.handleDeleteMeeting( record.meeting_id ) } />
            }
        ];

        const users_list = this.state.users_list.map( ( item, k ) => <Option value={ item.user_id }>{ item.full_name }</Option> )

        return (
            <div>
                <Row gutter={16}>
                    <Col span={6}>
                        <h2>
                            <Icon type="snippets" />
                            &nbsp; Meetings
                        </h2>
                    </Col>
                    <Col span={18}>

                        <span className="filter-wrapper">
                            <b>Filters</b> &nbsp;&nbsp;
                            <RangePicker 
                                onChange={ this.handleDateFilters }/>&nbsp;&nbsp;
                            <Select 
                                placeholder="Select Employee"
                                style={{ width: '150px' }}
                                defaultValue={ this.state.user }
                                onChange={ this.handleUserFilter }>
                                <Option value="all">All</Option>
                                { users_list }
                            </Select>
                            <Button
                                style={{ marginLeft: '10px' }}
                                onClick={ this.handleDownload }
                                icon="download"
                                className="fl_right">Download</Button>
                        </span>

                            
                    </Col>
                </Row>
                <Divider />
                <Row>
                    <Col>
                        <Table 
                            columns={ columns } 
                            dataSource={ this.state.data } />
                    </Col>
                </Row>
            </div>
        )
    }
}

function mapStatetoProps( state ){
    return {
        hr_meetings: state.hr_meetings
    }
}

export default connect( mapStatetoProps, { 
    get_meetings_reports, 
    update_meetins_fields,
    get_initial_users,
    delete_meeting })( MeetingReports );



// WEBPACK FOOTER //
// ./src/pages/hr-reports/meetings/index.js